<template>
    <div>

        <div v-if="isNew">
            <validation-observer ref="observer" v-slot="{ passes }">
                <b-form @submit.prevent="passes(createPage)">
                    <b-form-group label="URL" label-for="urlInput">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <b-form-input v-model="newPage" id="urlInput"></b-form-input>
                            <span class="validation">{{ errors[0] }}</span>
                        </validation-provider>
                    </b-form-group>
                    <b-button @click="isNew = false" variant="outline">Cancel</b-button>
                    <b-button type="submit">Create</b-button>
                </b-form>
            </validation-observer>
        </div>
        <div v-else>
            <p>Enter the webpages you want to train the AI model on. These will be used to help answer messages.</p>
            <template v-for="page in pages">
                <b-list-group-item class="d-flex align-items-center justify-content-between mb-3">
                    {{ page.url }}
                    <div>
                        <span class="badge mr-2" :class="getStatusClass(page.status)">{{ page.status }}</span>
                        <b-button @click="deletePage(page.id)" variant="outline-danger">Delete</b-button>
                    </div>
                </b-list-group-item>
            </template>

            <b-button @click="isNew = true" variant="primary">Add webpage</b-button>
            <p class="float-right">To retrain: delete and re-add page.</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            newPage: '',
            pages: [],
            isNew: false
        };
    },
    mounted() {
        this.fetchPages();

        // Refresh pages
        setInterval(() => {
            this.fetchPages();
        }, (1000 * 30));
    },
    props: {
        channelId: {
            type: Number,
            required: true,
        },
    },
    methods: {
        fetchPages() {
            // Make an HTTP request to fetch all pages
            this.$http.get(`channels/${this.channelId}/pages`)
                .then(response => {
                    this.pages = response.data;
                })
                .catch(error => {
                    console.error(error);
                });
        },
        createPage() {
            // Make an HTTP request to create a new page
            this.$http.post(`channels/${this.channelId}/pages`, {
                url: this.newPage
            })
                .then(response => {
                    // Reset the form and fetch updated pages
                    this.newPage = null;
                    this.isNew = false;

                    this.fetchPages();
                })
                .catch(error => {
                    console.error(error);
                });
        },
        deletePage(pageId) {
            // Make an HTTP request to delete a page
            this.$http.delete(`channels/${this.channelId}/pages/${pageId}`)
                .then(response => {
                    // Fetch updated pages
                    this.fetchPages();
                })
                .catch(error => {
                    console.error(error);
                });
        },
        getStatusClass(status) {
            return {
                'badge-success': status === 'trained',
                'badge-warning': status === 'queued'
            };
        }
    }
};
</script>
